import formatSummaryItems from 'components/Philanthropy/MyGiving/Payments/helpers/formatSummaryItems';
import { buildBatchTransactionData } from './helpers/buildBatchTransactionData';
import { buildSummaryItemsData } from './helpers/buildSummaryItemsData';
import { buildHiddenFieldsData } from './helpers/buildHiddenFieldsData';
import { formatTransactionData } from './helpers/formatTransactionData';

export const buildReviewData = ({
  oFormValues,
  aPayablePledges,
  aDeductiblePledges,
  aNonDeductiblePledges,
  oProfileData,
}) => {
  const oTransactionData = buildBatchTransactionData({
    oFormValues,
    aPayablePledges,
    aDeductiblePledges,
    aNonDeductiblePledges,
  });
  const aSummaryItems = buildSummaryItemsData({
    oFormValues,
    oTransactionData,
  });
  const oHiddenFieldsData = buildHiddenFieldsData({
    oFormValues,
    aSummaryItems,
    oProfileData,
  });
  return {
    oTransactionData: formatTransactionData(oTransactionData),
    aSummaryItems: formatSummaryItems(aSummaryItems),
    oHiddenFieldsData,
  };
};

export const buildConfirmationData = ({
  oFormValues,
  aPayablePledges,
  aDeductiblePledges,
  aNonDeductiblePledges,
}) => {
  const oTransactionData = buildBatchTransactionData({
    oFormValues,
    aPayablePledges,
    aDeductiblePledges,
    aNonDeductiblePledges,
  });
  const aSummaryItems = buildSummaryItemsData({
    oFormValues,
    oTransactionData,
  });
  return {
    aSummaryItems: formatSummaryItems(aSummaryItems),
  };
};
